import email from './email';

export const controllers = { email };
